module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/238-thailand-9ad170fecc52df8d46894e0109dfa981.svg";